<template>
  <dialog class="feedback-form" role="dialog">
    <div class="feedback-form__form-wrapper">
      <div class="feedback-form__close-btn-wrapper">
        <button @click="closeModal()" class="feedback-form__close-btn">
          Close <CloseBtn class="feedback-form__close-btn--icon" />
        </button>
      </div>
      <div class="feedback-form__content-wrapper">
        <div class="feedback-form__splash-wrapper">
          <div class="feedback-form__splash">
            <div class="feedback-form__victory">Victory!</div>
            <div class="feedback-form__copy">
              Nicely done, you have completed this course.
            </div>
          </div>
        </div>
        <div class="feedback-form__form-content-wrapper">
          <FeedbackFormContent
            :userId="userId"
            :courseId="courseId"
            @feedbackSubmitted="$emit('feedbackSubmitted')"
            @closeModal="$emit('closeModal')"
          />
        </div>
      </div>
    </div>
  </dialog>
</template>

<script>
import CloseBtn from '@/assets/icons/navigation/INE_close.svg'
import FeedbackFormContent from '@/components/user/course-feedback/feedback-form/FeedbackFormContent.vue'

export default {
  name: 'FeedbackForm',
  components: {
    CloseBtn: { ...CloseBtn, name: 'CloseBtn' },
    FeedbackFormContent,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
    courseId: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', true)
    },
  },
  created() {
    const body = document.querySelector('body')
    body.classList.add('modal-open')
  },
  destroyed() {
    const body = document.querySelector('body')
    body.classList.remove('modal-open')
  },
}
</script>

<style lang="scss" scoped>
.feedback-form {
  $this: &;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(21, 21, 21, 0.8);
  z-index: 9999;
  &__form-wrapper {
    background: var(--light-gray);
    border: 1px solid #707070;
    padding: 0 5px 5px 5px;
    position: relative;
    overflow-y: scroll;
    @include desktop {
      overflow-y: auto;
      max-width: 1400px;
    }
  }
  &__close-btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 10px 0 10px;
  }
  &__close-btn {
    display: flex;
    align-items: center;
    color: var(--white);
    font-size: 1rem;
    background-color: transparent;
    border: none;
    transition: 0.3s all ease;
    text-decoration: underline;
    &:hover {
      cursor: pointer;
      color: var(--orange);
      #{$this}__close-btn--icon {
        fill: var(--orange);
      }
    }
    &--icon {
      fill: var(--white);
      height: 1rem;
      transition: 0.3s all ease;
      margin: 3px 5px 0 5px;
    }
  }
  &__content-wrapper {
    width: 100%;
    background: var(--white);
    display: flex;
    flex-wrap: wrap;
  }
  &__splash-wrapper {
    width: 100%;
    min-height: 500px;
    @include desktop {
      width: 40%;
    }
  }
  &__splash {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url('https://s3.amazonaws.com/my.ine.com/assets/feedback-form/INE_FinishCourse_mobile.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    @include desktop {
      background-image: url('https://s3.amazonaws.com/my.ine.com/assets/feedback-form/INE_FinishCourse.png');
    }
  }
  &__victory {
    font-weight: 700;
    font-size: 2rem;
    position: absolute;
    top: 10%;
    left: 1%;
    @include desktop {
      top: 40%;
      right: 43%;
      left: unset;
    }
  }
  &__copy {
    color: var(--white);
    position: absolute;
    top: 10%;
    left: 70%;
    @include desktop {
      width: 50%;
      top: 50%;
      right: 25%;
      left: unset;
    }
  }
  &__form-content-wrapper {
    width: 100%;
    @include desktop {
      width: 60%;
    }
  }
}
</style>
